<div class="wrapper">
    <div class="overlay" *ngIf="isLoading | async">
        <div class="spinner-wrapper">
            <bc-loader speedLoader='1' sizeLoader='lg'></bc-loader>
            <span>Validando...</span>
        </div>
    </div>
</div>
